import { TmsEventType, } from '../DataLayer.types';
import { formatDataLayerString } from '../DataLayerUtils';
import DataLayerBaseEvent from './DataLayerBaseEvent';
export default class FacetRemovedEvent extends DataLayerBaseEvent {
    update(tms, payload, errorHandler) {
        const { feature: { featureGroup, featureLabel }, } = payload;
        this.updateDataLayer(tms, TmsEventType.link, 'facet-remove selection', {
            facet_key: formatDataLayerString(featureGroup),
            facet_value: formatDataLayerString(featureLabel),
        }, errorHandler);
    }
}
//# sourceMappingURL=FacetRemovedEvent.js.map